import { render, staticRenderFns } from "./AreaAddEdit.vue?vue&type=template&id=00e81dd0"
import script from "./AreaAddEdit.vue?vue&type=script&lang=js"
export * from "./AreaAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports